module.exports = __webpack_public_path__ + "img/woman4.2cb0ea94.png";